import { Component, ChangeDetectionStrategy } from '@angular/core';


@Component({
	selector: 'experience-engagements-tab-2-part',
	standalone: true,
	templateUrl: './experience-engagements-tab-2.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: [`./experience-engagements-tab-2.part.scss`],
})
export class ExperienceEngagementsTab2Part {
}
